import { render } from "./ArtworkRequestForm.vue?vue&type=template&id=5900cfd8&scoped=true"
import script from "./ArtworkRequestForm.vue?vue&type=script&lang=js"
export * from "./ArtworkRequestForm.vue?vue&type=script&lang=js"

import "./ArtworkRequestForm.vue?vue&type=style&index=0&id=5900cfd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5900cfd8"]])

export default __exports__